import { api } from './api'

export const fetchReportCustomer = (query) => api.get('/report', query)
export const fetchTotalSales = (query) => api.get('/report/total-sales', query)
export const fetchAverageOrders = (query) => api.get('/report/average-order', query)

export const fetchInvoiceAnalytics = (query) => api.get('/report/invoice-analytics', query)
export const fetchDriverRouteAnalysis = (query) => api.get('/report/driver-route-analysis', query)
export const exportDriverRouteAnalysis = (query) =>
  api.get('/report/driver-route-analysis/export', query, { responseType: 'blob' })
